
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.122 3.37c0-.492.102-.936.306-1.332.204-.396.456-.702.756-.917.3-.216.593-.384.881-.504.288-.12.54-.18.756-.18h.144a.757.757 0 00.18-.018c.467 0 .905.09 1.313.27.408.18.99.51 1.745.99l.9.575c.707.42 1.367.63 1.979.63.671 0 1.247-.174 1.727-.522.48-.348.75-.822.81-1.421 0-.132.023-.252.071-.36.048-.108.108-.162.18-.162.168 0 .252.186.252.558 0 .791-.282 1.475-.845 2.05-.564.576-1.284.87-2.16.882-.491 0-1.013-.126-1.565-.378a7.464 7.464 0 01-1.439-.845 7.464 7.464 0 00-1.44-.846c-.55-.252-1.055-.384-1.51-.396-.72 0-1.314.198-1.782.594-.467.396-.72.846-.755 1.35-.024.347-.108.521-.252.521-.168 0-.252-.18-.252-.54z","fill":"#000C1F"}}),_c('rect',{attrs:{"x":".622","y":"8.409","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}})])
          )
        }
      }
    